export default __webpack_public_path__ + "static/media/No50.a756386f.jpg";